export default __webpack_public_path__ + "static/media/3.b3c8f04e.png";